import { render, staticRenderFns } from "./bingli_tab2.vue?vue&type=template&id=c4456b9a&scoped=true&"
import script from "./bingli_tab2.vue?vue&type=script&lang=js&"
export * from "./bingli_tab2.vue?vue&type=script&lang=js&"
import style0 from "./bingli_tab2.vue?vue&type=style&index=0&id=c4456b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4456b9a",
  null
  
)

export default component.exports